// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsMessagesStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { hideElementOnPrint, maxLengthAttr } from "@keller/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsMessagesStyles.messageTextArea = {
    css: css`
        min-width: 100%;
        max-width: 100%;
    `,
    cssOverrides: {
        formField: css`
            margin-bottom: 20px;
            max-height: 500px;
            ${hideElementOnPrint}
        `,
    },
    maxLength: maxLengthAttr.quoteNotes,
};

rfqQuoteDetailsMessagesStyles.sendButton = {
    css: css`
        ${hideElementOnPrint}
    `,
};

rfqQuoteDetailsMessagesStyles.messagesContainer = {
    gap: 20,
    css: css`
        ${GridOffset} {
            margin-top: 20px;
        }
        ${GridItemStyle} {
            margin: 0 10px;
            padding: 10px 0;
            border-top: 1px solid ${getColor("common.border")};
        }

        @media print {
            ${GridOffset} {
                margin-top: 0;
            }
        }
    `,
};
